import { useTranslation } from 'react-i18next';
import { Button } from '../shadcn/Button';

export function CancelButton({ onCancel, disabled }: { onCancel: () => void; disabled?: boolean }) {
  const { t } = useTranslation();

  return (
    <Button className="mt-4 w-full" variant="outline" onClick={onCancel} disabled={disabled}>
      {t('Common.cancel')}
    </Button>
  );
}
